import { createSlotsContext } from '@grandvisionhq/slots';

const [OrderedProductDetailSlotProvider, useOrderedProductDetailSlot] = createSlotsContext({
    displayName: 'OrderedProductDetailSlotsContext'
});

export { OrderedProductDetailSlotProvider, useOrderedProductDetailSlot };
//# sourceMappingURL=context.js.map
